var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-checkbox',{attrs:{"checked":_vm.checked},on:{"change":_vm.handleChange}},[_vm._v(" 전체선택 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }